import { render, staticRenderFns } from "./schoolList.vue?vue&type=template&id=66d8a830&scoped=true"
import script from "./schoolList.vue?vue&type=script&lang=js"
export * from "./schoolList.vue?vue&type=script&lang=js"
import style0 from "./schoolList.vue?vue&type=style&index=0&id=66d8a830&prod&lang=scss&scoped=true"
import style1 from "./schoolList.vue?vue&type=style&index=1&id=66d8a830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8a830",
  null
  
)

export default component.exports